import React from 'react';
import QuizApp from './components/QuizApp';

function App() {
  return (
    <div>
      <QuizApp />
    </div>
  );
}

export default App;
